import { gql } from '@apollo/client'

export default gql`
  fragment SalaryOfYear on Salary {
    id
    amount
    fromDate
    toDate
  }
`
